<template>
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="isOpen"
      persistent
      max-width="1000px"
    >
      <v-card class="create-bridge-signing">
        <v-card-title class="toolbar primary white--text pa-2">
          <v-icon dark>
            note_add
          </v-icon>
          <h3
            class="title ml-2"
          >
            Show Settlement Actions
          </h3>
          <v-spacer />
          <v-btn
            color="secondary"
            flat
            @click="onToggleOpen"
          >
            X
          </v-btn>
        </v-card-title>
        <v-progress-linear
          v-if="isLoading"
          :indeterminate="true"
          class="ma-0"
        />
        <v-alert
          v-if="error"
          type="error"
          :value="true"
        >
          {{ error }}
        </v-alert>
        <h3 v-if="!isSettlement && !isRollbackValid">
          No Actions Available
        </h3>
        <div class="mt-2 pb-2">
          <v-layout
            row
            wrap
          >
            <SettlementActionCard
              v-if="settlement.status === settlementStatus.NEEDS_MANUAL_SOLVING &&
                settlement.eventType !== 'vaultTransactionFailed' &&
                isSettlement"
              title="Needs Manual Solving"
              description="Order again. Payment needs to be already marked as paid."
              link-title="Retrieve the order status again"
              @click="retryOrderStatus"
            />
            <SettlementActionCard
              v-if="settlement.status === settlementStatus.NEEDS_MANUAL_SOLVING &&
                !isSettlement"
              title="Needs Manual Solving"
              description="Retry Cancellation of Token Transfer"
              link-title="Retry token transfer cancellation"
              @click="retryCancelTokenTransfer"
            />
            <SettlementActionCard
              v-if="settlement.status === settlementStatus.NEEDS_MANUAL_SOLVING &&
                settlement.eventType === 'vaultTransactionFailed' &&
                isSettlement"
              title="Needs Manual Solving"
              description="Retires the token tranfer if already paid but only the token transfer failed."
              link-title="Retry token transfer"
              @click="retryTokenTransfer"
            />
            <SettlementActionCard
              v-if="settlement.status === settlementStatus.NEEDS_MANUAL_SOLVING &&
                settlement.eventType !== 'vaultTransactionFailed' &&
                isSettlement"
              title="Needs Manual Solving"
              description="Re-Checks if settlement is paid and tries to order."
              link-title="Retry PaymentPrepaying"
              @click="retryPaymentPrepaying"
            />

            <SettlementActionCard
              v-if="settlement.status === settlementStatus.RUNNING &&
                settlement.eventType === 'paymentDebiting' &&
                isSettlement"
              title="Debit-Stuck"
              description="Checks if settlement is paid by debit and tries to order."
              link-title="Try PaymentPrepaying"
              @click="retryPaymentPrepaying"
            />

            <SettlementActionCard
              v-if="isAbortValid &&
                isSettlement"
              title="Abort settlement"
              description="Only works when not ever finally paid (i.e. works prior to
                      any payment or during paymentEscrowCreated, paymentEscrowGotOutstandingAmount)"
              link-title="Abort settlement"
              @click="abortSettlement"
            />

            <SettlementActionCard
              v-if="isRollbackValid"
              title="Rollback"
              description="Rollback settlement only works if fully paid but not ordered."
              link-title="Rollback settlement"
              @click="rollbackSettlement"
            />

            <SettlementActionCard
              v-if="settlement.status === settlementStatus.SUCCESS &&
                isSettlement"
              title="Cancel"
              description="Cancel a single Settlement"
              link-title="Cancel settlement"
              :show-cancel-warning="true"
              @click="cancelSettlement"
            />

            <SettlementActionCard
              v-if="!isWarningOpen && !isVaultTransactionFailed &&
                isSettlement"
              title="Replay Last Event"
              description="Replay a single Settlement"
              link-title="Replay Last Event"
              @click="isWarningOpen=true"
            />
            <SettlementActionCard
              v-if="isWarningOpen &&
                isSettlement"
              title="Replay Last Event"
              description="Warning: You should only execute this action if
                you really know what you are doing! The latest
                event will be triggered - regardless what the last
                state is!"
              link-title="Execute NOW: Replay Last Event"
              @click="replayLastEvent"
            />
          </v-layout>
        </div>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>

import axios from 'axios';
import SettlementActionCard from './SettlementActionCard';
import SettlementStatusEnum from '../../../enum/settlements/SettlementStatus';

export default {
  name: 'ShowSettlementActions',

  components: {
    SettlementActionCard,
  },
  props: {
    type: {
      type: String,
      required: true,
      default: 'cancel',
    },
    settlement: {
      type: Object,
      required: true,
    },
    isOpen: {
      type: Boolean,
      required: true,
    },
    toggleOpen: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    selectedUser: null,
    isOpenProp: this.isOpen,
    isLoading: false,
    isWarningOpen: false,
    error: null,
  }),
  computed: {
    settlementStatus() {
      return SettlementStatusEnum;
    },
    isAbortValid() {
      return this.settlement.status === this.settlementStatus.RUNNING ||
        (this.settlement.status === this.settlementStatus.NEEDS_MANUAL_SOLVING &&
          this.settlement.eventType === 'paymentStuck');
    },
    isSettlement() {
      return this.type === 'settlement';
    },
    isRollbackValid() {
      if (this.type === 'settlement') {
        return this.settlement.status === this.settlementStatus.RUNNING ||
        (this.settlement.status === this.settlementStatus.NEEDS_MANUAL_SOLVING &&
          this.settlement.eventType === 'vaultTransactionFailed');
      }

      return this.settlement.status === this.settlementStatus.NEEDS_MANUAL_SOLVING;
    },
    isVaultTransactionFailed() {
      return this.settlement.status === this.settlementStatus.NEEDS_MANUAL_SOLVING &&
        this.settlement.eventType === 'vaultTransactionFailed';
    },
  },
  methods: {
    retryCancelTokenTransfer() {
      this.isLoading = true;
      axios.post(
        `${window.BASE_API.STRATEGIES_SETTLEMENT}/settlement/cancel/manualTokenTransfer`,
        { settlementId: this.settlement.id },
      ).then(() => {
        this.$store.dispatch('fetchCanceledSettlements');
        this.onToggleOpen();
      }).catch((error) => {
        this.error = `${error.message}: ${error.response.data.message}`;
        this.isLoading = false;
      });
    },
    retryTokenTransfer() {
      this.isLoading = true;
      axios.post(
        `${window.BASE_API.STRATEGIES_SETTLEMENT}/settlement/retryTokenTransfer`,
        { settlementId: this.settlement.id },
      ).then(() => {
        this.$store.dispatch('fetchStrategiesSettlements');
        this.onToggleOpen();
      }).catch((error) => {
        this.error = `${error.message}: ${error.response.data.message}`;
        this.isLoading = false;
      });
    },
    retryOrderStatus() {
      this.isLoading = true;
      axios.get(
        `${window.BASE_API.STRATEGIES_SETTLEMENT}/settlement/${this.settlement.id}/retryOrderStatus`,
      ).then(() => {
        this.$store.dispatch('fetchStrategiesSettlements');
        this.onToggleOpen();
      }).catch((error) => {
        this.error = `${error.message}: ${error.response.data.message}`;
        this.isLoading = false;
      });
    },
    retryPaymentPrepaying() {
      this.isLoading = true;
      axios.get(
        `${window.BASE_API.STRATEGIES_SETTLEMENT}/settlement/${this.settlement.id}/retryPaymentPrepaying`,
      ).then(() => {
        this.$store.dispatch('fetchStrategiesSettlements');
        this.onToggleOpen();
      }).catch((error) => {
        this.error = `${error.message}: ${error.response.data.message}`;
        this.isLoading = false;
      });
    },
    abortSettlement() {
      this.isLoading = true;
      axios.put(
        `${window.BASE_API.STRATEGIES_SETTLEMENT}/settlement/${this.settlement.id}/abort`,
      ).then(() => {
        this.$store.dispatch('fetchStrategiesSettlements');
        this.onToggleOpen();
      }).catch((error) => {
        this.error = `${error.message}: ${error.response.data.message}`;
        this.isLoading = false;
      });
    },
    rollbackSettlement() {
      let apiCall;
      let settlementData;
      if (this.type === 'settlement') {
        apiCall = axios.put(`${window.BASE_API.STRATEGIES_SETTLEMENT}/settlement/${this.settlement.id}/rollback`);
        settlementData = 'fetchStrategiesSettlements';
      } else {
        apiCall = axios.post(`${window.BASE_API.STRATEGIES_SETTLEMENT}/settlement/cancel/manualRollback`,
          { settlementId: this.settlement.id });
        settlementData = 'fetchCanceledSettlements';
      }
      this.isLoading = true;
      apiCall.then(() => {
        this.$store.dispatch(settlementData);
        this.onToggleOpen();
      }).catch((error) => {
        this.error = `${error.message}: ${error.response.data.message}`;
        this.isLoading = false;
      });
    },
    cancelSettlement() {
      this.isLoading = true;
      axios.post(
        `${window.BASE_API.STRATEGIES_SETTLEMENT}/settlement/cancel`,
        { settlementId: this.settlement.id },
      ).then(() => {
        this.$store.dispatch('fetchStrategiesSettlements');
        this.onToggleOpen();
      }).catch((error) => {
        this.error = `${error.message}: ${error.response.data.message}`;
        this.isLoading = false;
      });
    },
    replayLastEvent() {
      this.isLoading = true;
      axios.put(
        `${window.BASE_API.STRATEGIES_SETTLEMENT}/settlement/${this.settlement.id}/replay`,
      ).then(() => {
        this.$store.dispatch('fetchStrategiesSettlements');
        this.isWarningOpen = false;
        this.onToggleOpen();
      }).catch((error) => {
        this.error = `${error.message}: ${error.response.data.message}`;
        this.isLoading = false;
      });
    },
    onToggleOpen() {
      this.toggleOpen();
      this.error = null;
      this.isLoading = false;
    },
  },
};
</script>

<style lang="scss">
  .create-bridge-signing {
    .v-card__title {
      padding: 24px;
    }

    .v-card__text {
      max-height: 65vh;
      overflow: auto;
      padding-top: 32px;
    }

    .v-card__actions {
      border-top: 1px solid rgba(0, 0, 0, 0.12);
    }

    .radio-label {
      position: absolute;
      font-size: 16px;
      text-align: left;
      max-width: 133%;
      height: 20px;
      left: 12px;
      line-height: 20px;
      color: rgba(0, 0, 0, 0.54);
      -webkit-transform: translateY(-18px) scale(0.75);
      transform: translateY(0px) translateX(-6px) scale(0.75);
    }

    .subheading {
      padding: 8px;
      background: white;
      color: rgba(0, 0, 0, 0.54);
      top: -20px;
      left: 8px;
      position: absolute;
      display: flex;
      align-items: center;
    }

    .form-group {
      padding: 16px;
      margin: 0 0 24px 0;
      border: 1px solid rgba(0, 0, 0, 0.12);
      border-radius: 5px;
      position: relative;
    }

    .container.grid-list-md .layout:not(:only-child) {
      margin: 0 0 24px 0;
    }

    .v-input--selection-controls.v-input .v-label {
      text-transform: capitalize;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/settlements/dialog/ShowSettlementActions.vue